import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export interface AnalyticsFilterEntityOption {
  id: number
  name: string
}

export interface AnalyticsFilterOptions {
  cities: string[]
  districts: string[]
  typologies: string[]
  developers: AnalyticsFilterEntityOption[]
  brokers: AnalyticsFilterEntityOption[]
  architects: AnalyticsFilterEntityOption[]
}

/**
 * Fetches distinct cities / districts / typologies for the analytics filter bar
 * dropdowns. The response is cached for 30 minutes since it reflects the full
 * domain and rarely changes during a session.
 */
export function useAnalyticsFilterOptions() {
  return useQuery<AnalyticsFilterOptions>({
    queryKey: ['analytics', 'filter-options'],
    queryFn: async () => {
      const response = await api.get('/analytics/filters/options')
      return response.data as AnalyticsFilterOptions
    },
    staleTime: 30 * 60 * 1000,
  })
}
